import initialState from './initialState';
import * as types from '../constants/actionTypes';

export default function screenSummaryReducer(state = initialState.screenSummary, action) {
  switch (action.type) {
    case types.UPDATE_ORIENTATION_SCREEN: {
      const orientation = action.orientation ? action.orientation : initialState.screenSummary.orientation;
      return state.set('orientation', orientation);
    }
    case types.UPDATE_PREVIOUS_SCREEN: {
      return state.set('preScreen', action.preScreen);
    }
    case types.UPDATE_STATUS_SHOULD_SELECT_CONVERSATION_SCREEN: {
      return state.set('shouldSelectConversationScreen', action.data);
    }
    case types.UPDATE_USERID_SHOULD_SELECT_ON_MESSENGER_SCREEN: {
      return state.set('directConversation', action.data);
    }
    case types.RESET_USERID_SHOULD_SELECT_ON_MESSENGER_SCREEN: {
      return state.set('directConversation', initialState.screenSummary.directConversation);
    }
    case types.USER_LOGOUT_SUCCESS: {
      state = initialState.screenSummary;
      return state;
    }
    default:
      return state;
  }
}
